import {
  AsianOpenBetPanelResponse,
  OpenBetPanelResponse,
} from "app/types/openBetsPanelType";
import { getDataWithParams as getDataWithParamsV3 } from "../helpers/apiHelperV3";
import { urls } from "./urls";

import type { Pagination } from "app/types/paginateType";

/**
 * fetch asian open bets normal list from API v3
 */
export interface FetchOpenBetsNormalListPayload extends Pagination {
  filter?: string;
  runnerId?: number;
  competitionNavNodeId?: number;
}

export const fetchOpenBetsNormalList = (
  payload: FetchOpenBetsNormalListPayload
): any => {
  let url: string = urls.reports.API_REPORTS_BETS_CURRENT_NORMAL();

  const params: {
    filter?: string;
    page?: number;
    size?: number;
    runnerId?: number;
    competitionNavNodeId?: number;
  } = {};

  params["filter"] = payload && payload.filter;
  params["page"] = payload && payload.page;
  params["size"] = payload && payload.size;

  if (payload.runnerId) params["runnerId"] = payload.runnerId;
  if (payload.competitionNavNodeId)
    params["competitionNavNodeId"] = payload.competitionNavNodeId;

  if (params["runnerId"] || params["competitionNavNodeId"]) {
    url = urls.reports.API_REPORTS_BETS_CURRENT_MATCH_LEAGUE();
  }

  return getDataWithParamsV3(url, params);
};

/**
 * fetch asian open bets normal list from API v3
 */

export interface FetchOpenBetsLeagueListPayload {
  filter?: string;
}

export const fetchOpenBetsLeagueList = (
  payload: FetchOpenBetsLeagueListPayload
): any => {
  const url = urls.reports.API_REPORTS_BETS_CURRENT_LEAGUE();

  const params: {
    filter?: string;
  } = {};
  params["filter"] = payload && payload.filter;

  return getDataWithParamsV3(url, params);
};

/**
 * fetch asian open bets normal list from API v3
 */

export interface FetchOpenBetsMatchListPayload {
  filter?: string;
}
export const fetchOpenBetsMatchList = (
  payload: FetchOpenBetsMatchListPayload
): any => {
  const url = urls.reports.API_REPORTS_BETS_CURRENT_MATCH();

  const params: {
    filter?: string;
  } = {};
  params["filter"] = payload && payload.filter;

  return getDataWithParamsV3(url, params);
};

/**
 * fetch asian open bets panel list from API v3
 */
export interface FetchOpenBetsPanelListPayload extends Pagination {
  betType?: string;
}
export const fetchAsianOpenBetsPanelList = (
  payload: FetchOpenBetsPanelListPayload
): Promise<AsianOpenBetPanelResponse> => {
  const url = urls.reports.API_REPORTS_OPEN_BETS_CURRENT_PANEL_ASIAN();

  const params: {
    size?: number;
    page?: number;
    betType?: string;
  } = {};
  params["size"] = payload && payload.size;
  params["page"] = payload && payload.page;
  params["betType"] = payload && payload.betType;

  return getDataWithParamsV3(url, params);
};

/**
 * fetch open bets panel list from API v3
 */
export interface FetchOpenBetsPanelListPayload extends Pagination {
  betType?: string;
}
export const fetchOpenBetsPanelList = (
  payload: FetchOpenBetsPanelListPayload
): Promise<OpenBetPanelResponse> => {
  const url = urls.reports.API_REPORTS_OPEN_BETS_CURRENT_PANEL();

  const params: {
    size?: number;
    page?: number;
    betType?: string;
  } = {};
  params["size"] = payload && payload.size;
  params["page"] = payload && payload.page;
  params["betType"] = payload && payload.betType;

  return getDataWithParamsV3(url, params);
};
